import React from 'react';
import { Text } from '@spark';
import noMatchesIllustration from '@/shared/assets/illustrations/projects-no-matches.svg';
import { NO_MATCHES_BODY, getNoMatchesTitle } from './noMatchesTitle';
import './ProjectsNoMatchesState.css';

/**
 * Projects zero-state when the search/filters exclude every project
 * (Figma 9750:36409): "0 Items" count row, illustration, title that quotes
 * the search term, and a hint to adjust keywords/filters. No CTA.
 */
export const ProjectsNoMatchesState = ({ searchValue = '' }) => (
    <div className="projects-no-matches fs-unmask" data-testid="projects-no-matches">
        <Text as="p" variant="detail-regular" color="primary" className="projects-no-matches__count">
            0 Items
        </Text>
        <div className="projects-no-matches__body">
            <img
                className="projects-no-matches__illustration"
                src={noMatchesIllustration}
                alt=""
                aria-hidden="true"
            />
            <div className="projects-no-matches__copy">
                <Text as="h3" variant="heading-5-semibold" color="primary" className="projects-no-matches__title">
                    {getNoMatchesTitle(searchValue)}
                </Text>
                <Text as="p" variant="base-regular" color="secondary" className="projects-no-matches__hint">
                    {NO_MATCHES_BODY}
                </Text>
            </div>
        </div>
    </div>
);

export default ProjectsNoMatchesState;
